import React from 'react';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import SubmissionDetails from '../../../SubmissionDetails';
import Stats from '../../../Stats';
import { useScrollToDeviationComments } from '../../../DeviationPage/_partials/Comments/useScrollToDeviationComments';
import JournalTags from '../../Details/_partials/JournalTags';
import Benefit from '../../TierProductCardDumb/Benefit';
import { getTierDescription } from '../../_helpers';
import s from './Tier.scss';
var TierContent = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, _c = _b.extended, _d = _c === void 0 ? {} : _c, tags = _d.tags, _e = _b.tier, _f = _e === void 0 ? {} : _e, _g = _f.benefits, benefits = _g === void 0 ? [] : _g, _h = _a.withArtist, withArtist = _h === void 0 ? true : _h;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var scrollToDeviationComments = useScrollToDeviationComments();
    return (React.createElement(React.Fragment, null,
        withArtist && (React.createElement("div", { className: s['author-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation }))),
        React.createElement("div", { className: s['stats'] },
            React.createElement(Stats, { deviation: deviation, withSubscriberCount: true, withViewCount: false, withBadges: false, onCommentClick: scrollToDeviationComments })),
        tags && React.createElement(JournalTags, { tags: tags }),
        isExtendedLoaded && (React.createElement("div", { className: s['text-content'] },
            React.createElement("p", { className: s['description'] }, getTierDescription(deviation)),
            React.createElement("ul", { className: s['benefits'] }, benefits.map(function (benefit) { return (React.createElement(Benefit, { key: benefit, benefit: benefit, className: s['benefit'] })); }))))));
};
TierContent.displayName = 'TierContent';
export default TierContent;
//# sourceMappingURL=Tier.js.map